import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const MarkerIcon = props => (
  <SvgIcon viewBox="0 0 100 100" {...props}>
    <g>
      <path d="M24 52l25 26c15,-18 31,-36 46,-54 7,-8 8,-6 -2,-17 -11,-11 -9,-9 -18,-1l-51 46zm-13 32l8 8c4,-2 4,-5 16,-2 2,1 5,-2 7,-4 2,-2 4,-4 5,-6l-25 -26 -5 5c-2,2 -4,3 -4,7 1,3 2,5 2,9 0,4 -2,5 -4,8zm-11 12l15 0 1 -1 -8 -8 -8 9zm0 0l96 0 0 4 -96 0 0 -4z" />
    </g>
  </SvgIcon>
);

export default MarkerIcon;
